import moment, { unitOfTime } from "moment-timezone";

export function getCutOffPeriodForBookingAndConfirmingMeetings(): [
	moment.DurationInputArg1,
	unitOfTime.Base
] {
	return [2, "hours"];
}
